import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", {
        email: email.trim().toLowerCase(),
        origin_url: window.location.origin,
      });
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto px-4 py-20 text-center animate-fade-up" data-testid="forgot-sent-page">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-olive-100 text-olive-600 mx-auto">
          <CheckCircle2 className="h-8 w-8" />
        </div>
        <h1 className="mt-6 font-serif text-3xl text-olive-700">Tjek din indbakke</h1>
        <p className="mt-3 text-brown-600 text-sm">
          Hvis der findes en konto med <strong>{email}</strong>, har vi sendt et nulstillingslink.
          Linket er gyldigt i 60 minutter.
        </p>
        <p className="mt-3 text-xs text-brown-500">
          Får du ikke en email? Tjek spam, eller kontakt support.
        </p>
        <Link to="/login" className="btn-secondary mt-8 inline-flex" data-testid="back-to-login">
          Tilbage til log ind
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 py-16 animate-fade-up" data-testid="forgot-password-page">
      <div className="eyebrow">Glemt adgangskode</div>
      <h1 className="mt-3 font-serif text-4xl text-olive-700">Nulstil din adgangskode</h1>
      <p className="mt-3 text-brown-600 text-sm">
        Skriv din email, så sender vi et nulstillingslink. Linket er gyldigt i 60 minutter.
      </p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <label className="block text-sm mb-1 text-brown-600">E-mail</label>
          <input
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="field"
            placeholder="dig@eksempel.dk"
            data-testid="forgot-email"
          />
        </div>
        {err && (
          <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-xl px-4 py-2" data-testid="forgot-error">
            {err}
          </div>
        )}
        <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="forgot-submit">
          <Mail className="h-4 w-4" /> {busy ? "Sender…" : "Send nulstillingslink"}
        </button>
      </form>

      <div className="mt-6 text-sm text-brown-500">
        <Link to="/login" className="text-olive-600 hover:underline" data-testid="back-to-login-link">
          ← Tilbage til log ind
        </Link>
      </div>
    </div>
  );
}
